import type { CSSProperties } from 'react';

import { type BadgeSize, FlexAligner } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { responsive } from '@/utils';

import type { LocalizedObservationBreakdownEntry } from './fishObservationGallery.types.ts';
import { LiceObservationBadge } from './LiceObservationBadge.tsx';

type ObservationBreakdownBadgesProps = {
  entries: LocalizedObservationBreakdownEntry[];
  size: BadgeSize;
  style?: CSSProperties;
};

/** One badge per breakdown entry, with the welfare score as a suffix to the right of the label. */
export const ObservationBreakdownBadges = ({
  entries,
  size,
  style,
}: ObservationBreakdownBadgesProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('orbitOne');
  const numberFormat = new Intl.NumberFormat(language);

  return (
    <FlexAligner
      fullWidth={false}
      alignment='center-left'
      gap={responsive.spacing.small}
      wrap
      style={style}
    >
      {entries.map(({ id, category, label, score }) => (
        <LiceObservationBadge
          key={id}
          category={category}
          size={size}
          label={label}
          suffix={
            score === undefined
              ? undefined
              : t('welfare.score', { score: numberFormat.format(score) })
          }
        />
      ))}
    </FlexAligner>
  );
};
